// extracted by mini-css-extract-plugin
module.exports = {"base":"ProductTeaserImage-module-base","isCover":"ProductTeaserImage-module-is-cover"};